export default __webpack_public_path__ + "static/media/doubleCoronaClosed.10e5baa5.jpg";